var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02001 21H2.5C1.122 21 0 19.879 0 18.5V2.5C0 1.121 1.122 0 2.5 0H14.5C15.878 0 17 1.121 17 2.5V8.56001C17 8.83601 16.776 9.06001 16.5 9.06001C16.224 9.06001 16 8.83601 16 8.56001V2.5C16 1.673 15.327 1 14.5 1H2.5C1.673 1 1 1.673 1 2.5V18.5C1 19.327 1.673 20 2.5 20H9.02001C9.29601 20 9.52001 20.224 9.52001 20.5C9.52001 20.776 9.29601 21 9.02001 21Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.99902H3.5C3.224 8.99902 3 8.77502 3 8.49902C3 8.22302 3.224 7.99902 3.5 7.99902H13.5C13.776 7.99902 14 8.22302 14 8.49902C14 8.77502 13.776 8.99902 13.5 8.99902Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50001 13H3.5C3.224 13 3 12.776 3 12.5C3 12.224 3.224 12 3.5 12H9.50001C9.77601 12 10 12.224 10 12.5C10 12.776 9.77601 13 9.50001 13Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50001 5.00098H3.5C3.224 5.00098 3 4.77698 3 4.50098C3 4.22498 3.224 4.00098 3.5 4.00098H8.50001C8.77601 4.00098 9.00001 4.22498 9.00001 4.50098C9.00001 4.77698 8.77601 5.00098 8.50001 5.00098Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 23.999C13.916 23.999 11 21.083 11 17.499C11 13.915 13.916 10.999 17.5 10.999C21.084 10.999 24 13.915 24 17.499C24 21.083 21.084 23.999 17.5 23.999ZM17.5 11.999C14.467 11.999 12 14.467 12 17.499C12 20.531 14.467 22.999 17.5 22.999C20.533 22.999 23 20.531 23 17.499C23 14.467 20.533 11.999 17.5 11.999Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3571 20.5781C16.2629 20.5781 16.1686 20.542 16.0969 20.4702L13.8423 18.2136C13.6984 18.0696 13.6984 17.8367 13.8423 17.6927C13.9862 17.5487 14.2188 17.5487 14.3628 17.6927L16.3571 19.6888L20.606 15.4361C20.7499 15.2921 20.9825 15.2921 21.1265 15.4361C21.2704 15.5802 21.2704 15.813 21.1265 15.9571L16.6174 20.4702C16.5456 20.542 16.4513 20.5781 16.3571 20.5781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthMenuIcon);
export default __webpack_public_path__ + "static/media/auth_menu_icon.dd8c01001f285a036f55ffe40c957064.svg";
export { ForwardRef as ReactComponent };